<div class="wrapper d-flex flex-column">
    <div class="header d-flex row align-items-center">
        <div class="col-md-9">
            <h6 class="px-4 py-3">Catalog User Association</h6>
        </div>
        <div class="header-action-btn col-md-3 d-flex align-items-center justify-content-end pr-2">
            <button class="margin-right" nz-button nzType="default" (click)="ngOnInit()"
            [disabled]="!authService.webAdm">Reset</button>

            <button nz-button nzType="primary" (click)="UpdateUser()"
                [disabled]="!authService.webAdm">Save</button>
        </div>
    </div>
    <div class="form-container px-4 row g-3">
        <nz-transfer [nzDataSource]="list" [nzDisabled]="!authService.webAdm" [nzShowSelectAll]="false"
            [nzRenderList]="[renderList, renderList]" (nzSelectChange)="select($event)" (nzChange)="change($event)"
            [nzOperations]="['Add','Remove']" [nzListStyle]="{ 'width.px': 250, 'height.px': 300 }">

            <ng-template #renderList let-items let-direction="direction" let-stat="stat"
                let-onItemSelectAll="onItemSelectAll" let-onItemSelect="onItemSelect">

                <!-- 🔍 Custom Search Input INSIDE panel -->
                <div class="p-2">
                    <nz-input-group nzSearch class="mb-4 search-input-group d-flex mr-10"
                        [nzSuffix]="suffixIconStyleClear">
                        <input class="search-input" [ngModel]="direction === 'left' ? leftUserListSearch : rightUserListSearch" type="text"
                           (ngModelChange)="onSearchChange(direction, $event)" nz-input placeholder="Search User" #SearchStyleText />
                        <ng-template #suffixIconStyleClear>
                            <span class="close-icon" (click)="direction === 'left' ? leftUserListSearch = '' : rightUserListSearch='' "
                                class="px-1" nz-icon nzType="close-circle"></span>
                        </ng-template>
                    </nz-input-group>
                </div>

                <nz-table [nzFrontPagination]="false" [nzData]="$asTransferItems(items)" nzSize="small"
                    [nzScroll]="{ y: '280px' }" >
                    <thead>
                        <tr>
                            <th>
                                <label class="px-2" (nzCheckedChange)="onItemSelectAll($event)"
                                    [nzChecked]="stat.checkAll" nz-checkbox></label>
                               <b> {{ direction === 'right' ? 'Linked users' : 'Available Users' }} </b>
                            </th>
                        </tr>
                    </thead>

                    <tbody>
                        @for (data of items; track data.key) {
                        @if (matchSearch(data, direction)) {
                        <tr>
                            <td>
                                <label class="px-2" [nzChecked]="data.checked"
                                    (nzCheckedChange)="onItemSelect(data, $event)" nz-checkbox></label>
                                {{ data.title }}
                            </td>
                        </tr>
                        }
                        }
                    </tbody>
                </nz-table>
            </ng-template>
        </nz-transfer>
    </div>
</div>